<template>
  <TopNavigationSecondary
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:left>
      <LogoImagePrimary
        :useWordmark="expand"
        :style="getLogoStyle"
      />
    </template>
    <template v-slot:right>
      <LinkTenantPrimary
        :to="{ name: 'workspace' }"
        :truncate="true"
        :style="style.linkToWorkspace"
      >
        {{ tenant.name }}
      </LinkTenantPrimary>
      <UserDropdownPrimary
        v-bind="attrs.userDropdown"
        v-on="$listeners"
        :options="userDropdownOptions"
        :tenantUser="tenantUser"
        :style="style.userDropdown"
        @select-option="index => $emit('select-user-option', index)"
      />
    </template>
  </TopNavigationSecondary>
</template>

<script>
  import LinkTenantPrimary from '@modules/v2/link/link-tenant-primary'
  import LogoImagePrimary from '@modules/v2/image/logo-image-primary'
  import TopNavigationSecondary from '@modules/v2/layout/top-navigation-secondary'
  import UserDropdownPrimary from '@modules/v2/dropdown/user-dropdown-primary'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'
  import { WIDTH_LIMITS, Z_INDEXES } from '@js/constants'

  export default {
    name: 'TheHeaderSecondary',
    inheritAttrs: false,
    components: {
      LinkTenantPrimary,
      LogoImagePrimary,
      TopNavigationSecondary,
      UserDropdownPrimary,
    },
    props: {
      tenant: {
        type: Object,
        required: false,
        default: () => {},
      },
      tenantUser: {
        type: Object,
        required: false,
        default: () => {}
      },
      userDropdownOptions: {
        type: Array,
        required: false,
        default: () => [],
      },
      windowWidth: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    data: function () {
      return {
        expand: false,
        attrs: {
          userDropdown: {
            zIndexDropdown: Z_INDEXES.LAYOUT.HEADER_USER_DROPDOWN,
          },
        },
        style: {
          linkToWorkspace: {
            height: '32px',
            justifyContent: 'flex-end',
            padding: `0 ${Layout.space.md}`,
            width: '200px',
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.linkToWorkspace,
        {
          border: `solid ${this.color.dark5()}`,
          borderWidth: '0 1px 0 0',
        }
      );
    },
    mounted: function () {
      this.updateExpandFlag();
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      getLogoStyle: function () {
        return {
          height: '32px',
          minHeight: '32px',
          ...(this.expand ? {
            minWidth: '160px',
          } : {
            minWidth: '32px',
            width: '32px',
          }),
        };
      },
    },
    methods: {
      updateExpandFlag: function () {
        this.expand = this.windowWidth >= parseInt(WIDTH_LIMITS.HEADER.WORDMARK);
      },
    },
    watch: {
      windowWidth: function (newVal, oldVal) {
        this.updateExpandFlag();
      },
    },
  };
</script>
